var _rect, _rect2, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCometLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 150,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#ffffff",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#ffffff",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d13333",
    d: "M 340.726562 25.351562 C 330.609375 24.671875 289.007812 18.742188 186.320312 84.082031 C 83.644531 149.421875 29.589844 259.398438 75.855469 318.613281 C 85.582031 331.066406 124.480469 356.355469 169.984375 323.285156 C 198.597656 302.496094 207.363281 257.019531 232.988281 196.089844 C 250.492188 154.472656 289.773438 76.300781 344.621094 40.902344 C 361.734375 32.355469 346.558594 25.746094 340.726562 25.351562 Z M 340.726562 25.351562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f78c8c",
    d: "M 190.59375 145.210938 C 188.261719 135.878906 199.152344 107.488281 202.261719 99.707031 C 145.539062 125.515625 92.03125 202.066406 92.375 215.847656 C 92.429688 217.847656 93.601562 218.535156 96.078125 217.550781 C 143.644531 198.460938 174.347656 226.976562 182.496094 250.601562 C 183.335938 253.015625 184.382812 254.25 185.484375 254.480469 C 186.992188 254.796875 188.585938 253.160156 189.835938 249.570312 C 207.691406 198.292969 247.757812 104.710938 289.378906 68.976562 C 266.042969 80.257812 200.324219 128.875 190.59375 145.210938 Z M 190.59375 145.210938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4bdbd",
    d: "M 169.597656 139.378906 C 154.289062 146.664062 105.488281 193.941406 92.386719 215.847656 C 92.4375 217.847656 93.609375 218.535156 96.085938 217.550781 C 143.652344 198.460938 174.355469 226.976562 182.507812 250.601562 C 183.34375 253.015625 184.390625 254.25 185.492188 254.480469 C 185.996094 233.964844 184.683594 187.367188 204.996094 152.605469 C 169.207031 185.269531 160.265625 184.484375 169.597656 139.378906 Z M 169.597656 139.378906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 120.980469 233.4375 C 95.207031 233.4375 74.304688 254.332031 74.304688 280.113281 C 74.304688 305.890625 95.207031 326.78125 120.980469 326.78125 C 146.753906 326.78125 167.648438 305.890625 167.648438 280.113281 C 167.648438 254.332031 146.753906 233.4375 120.980469 233.4375 Z M 120.980469 233.4375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCometLogo);
export default __webpack_public_path__ + "static/media/cometLogo.554ea195695ebd393b2407cb7b2f71aa.svg";
export { ForwardRef as ReactComponent };